import styled from "styled-components";

export const GroupInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  .title {
    font: 600 0.8125rem/1.3125rem "Inter";
    color: ${({ theme }) => theme.classwork.imersive.tagTextColor};

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 15ch;

    @media (max-width: 1300px) {
      font-size: 0.75rem;
      line-height: 1.125rem;
    }

    @media (max-width: 400px) {
      max-width: 15ch;
    }
  }

  .progress {
    display: flex;

    align-items: center;
    gap: 1rem;

    .numbers {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .rate {
        font: 600 0.75rem/1.3125rem "Inter";
        color: ${({ theme }) => theme.classwork.imersive.dropdownTitle};

        @media (max-width: 1300px) {
          font-size: 0.75rem;
          line-height: 0.96rem;
        }
      }

      .conclusion-rate {
        font: 400 0.75rem/1.3125rem "Inter";
        color: ${({ theme }) => theme.classwork.imersive.textColor};

        @media (max-width: 1300px) {
          font-size: 0.75rem;
          line-height: 0.96rem;
        }
      }
    }
  }
`;

interface IProgressCircleProps {
  progressRate: number;
}

export const ProgressCircle = styled.div<IProgressCircleProps>`
  display: flex;

  .circular-progress {
    --size: 46px;
    --half-size: calc(var(--size) / 2);
    --stroke-width: 8px;
    --radius: calc((var(--size) - var(--stroke-width)) / 2);
    --circumference: calc(var(--radius) * pi * 2);
    --dash: calc((var(--progress) * var(--circumference)) / 100);
    animation: progress-animation 0.3s linear 0s 1 forwards;
  }

  .circular-progress circle {
    cx: var(--half-size);
    cy: var(--half-size);
    r: var(--radius);
    stroke-width: var(--stroke-width);
    fill: none;
  }

  .circular-progress circle.bg {
    stroke: ${({ theme }) => (theme.mode === "dark" ? "#373940" : "#DDDDDD")};
  }

  .circular-progress circle.fg {
    transform: rotate(-90deg);
    transform-origin: var(--half-size) var(--half-size);
    stroke-dasharray: var(--dash) calc(var(--circumference) - var(--dash));
    transition: stroke-dasharray 0.5s linear 0s;
    stroke: #3b82f6;
  }

  @media (max-width: 1300px) {
    svg {
      width: 35px;
      height: 35px;
    }
  }

  @property --progress {
    syntax: "<number>";
    inherits: false;
    initial-value: 0;
  }

  @keyframes progress-animation {
    from {
      --progress: 0;
    }
    to {
      --progress: ${({ progressRate }) => progressRate};
    }
  }
`;
